<template>
  <div class="auth-wrapper auth-v1 px-2">
    <b-row class="auth-inner m-0">
      <b-col
        cols="12"
        class="d-flex justify-content-center"
      >
        <b-img src="@/@core/assets/image/logo-komerce-new-tag.png" />
      </b-col>
      <b-card :class="modeLogin === true ? 'form-login  mt-2' : 'd-none'">
        <div class="mb-1 text-center text-[#333333] font-semibold text-[24px]">
          Masuk
        </div>
        <div class="mb-2 text-center text-[#828282] text-sm w-max-[300px]">
          Silahkan masuk dan memulai kemudahan mengelola e-commerce dalam 1
          tempat.
        </div>
        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{ invalid }"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="login"
          >
            <recaptcha-invisible ref="recaptcha" />
            <b-form-group
              label="Username atau Email"
              label-for="login-email"
              label-class="text-[#333333]"
              class="no-icon"
            >
              <validation-provider
                #default="{ errors }"
                label="Username atau Email"
                vid="email"
                rules="required"
                :custom-messages="custommessages1"
              >
                <b-form-input
                  id="login-email"
                  v-model="usernameEmail"
                  :state="errors.length > 0 ? false : null"
                  name="login-email"
                  placeholder="mitrakomerce@gmail.com"
                  @keypress="NoSpace($event)"
                />
                <small
                  v-if="errors[0]"
                  class="text-primary"
                >{{
                  errors[0]
                }}</small>
                <b-col
                  v-else-if="!!error || messageResendEmailVerification !== ''"
                >
                  <b-row
                    v-if="!!error"
                    class="align-items-center justify-content-between mt-50"
                  >
                    <small class="text-primary">
                      <strong>
                        {{ error }}
                      </strong>
                    </small>
                    <b-button
                      v-if="showResendEmailVerification"
                      class="ml-50 btn-icon"
                      variant="flat-primary"
                      size="sm"
                      @click="resendEmailVerification"
                    >
                      <b-spinner
                        v-if="loadingResendVerification"
                        small
                      />
                      <strong> Kirim Ulang </strong>
                    </b-button>
                  </b-row>
                  <b-row
                    v-if="messageResendEmailVerification !== ''"
                    class="align-items-center mt-50"
                  >
                    <small class="text-primary">
                      <strong>
                        {{ messageResendEmailVerification }}
                      </strong>
                    </small>
                  </b-row>
                </b-col>
              </validation-provider>
            </b-form-group>

            <!-- forgot password -->
            <b-form-group>
              <label
                class="text-[#333333]"
                for="login-password"
              >Password</label>
              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required"
                :custom-messages="custommessages"
              >
                <b-input-group
                  class="input-group-merge disable-icon"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="login-password"
                    v-model="password"
                    :state="errors.length > 0 ? false : null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    name="login-password"
                    placeholder="Masukkan password"
                    @keypress="NoSpace($event)"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              <div class="flex justify-end w-full">
                <button
                  type="button"
                  class="text-primary text-sm mt-[8px] focus:outline-none"
                  @click="
                    $router.push({
                      name: 'auth-forgot-password',
                    })
                  "
                >
                  Lupa Password?
                </button>
              </div>

              <span
                v-if="isShowErrorForgotPassword"
                class="my-[8px] text-sm text-[#E31A1A]"
              >
                Tidak bisa reset password, silahkan hubungi team Komerce
              </span>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group v-if="false">
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Remember Me
              </b-form-checkbox>
            </b-form-group>

            <!-- submit buttons -->
            <button
              type="submit"
              class="btn-submit w-full"
              :disabled="invalid"
              :class="invalid ? 'btnSubmitInvalid' : 'btnSubmitValid'"
            >
              <b-spinner
                v-if="loading"
                small
              />
              Masuk
            </button>
          </b-form>
        </validation-observer>

        <!-- </b-col> -->
      </b-card>

      <b-card :class="modeVerificationEmail === true ? 'mt-2 p-1' : 'd-none'">
        <b-card-title class="mb-1 text-center">
          <h3 class="text-black">
            <strong> Verifikasi Email </strong>
          </h3>
        </b-card-title>
        <b-card-text class="mb-1 text-center text-black">
          Cek email kamu, verifikasi telah dikirimkan. Belum menerima?
          {{ countTimerEmail === 0 ? 'Kirim ulang (60 detik)' : '' }}
        </b-card-text>
        <b-row class="justify-content-center mb-1">
          <small>Mohon tunggu {{ countTimerEmail }} detik untuk mengirim
            ulang.</small>
        </b-row>

        <b-row class="justify-content-center mb-1">
          <b-button
            :variant="countTimerEmail === 0 ? 'flat-primary' : 'flat-dark'"
            size="sm"
            :disabled="countTimerEmail !== 0"
            class="btn-icon"
            @click="resendEmailVerification"
          >
            Kirim Ulang
          </b-button>
        </b-row>

        <b-button
          variant="primary"
          block
          @click="handleChangeModePage"
        >
          Kembali Masuk
        </b-button>
      </b-card>
    </b-row>

    <recaptcha-invisible
      ref="recaptcha"
      :action="recaptchaAction"
    />
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BCardTitle,
  BLink,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BAlert,
  VBTooltip,
  BSpinner,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { $themeConfig } from '@themeConfig'
import secureLocalStorage from '@/libs/secureLocalstorage'
import { NoSpace } from '@/libs/helpers'

const RECAPTCHA_ACTION_LOGIN = 'LOGIN_MITRA'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BButton,
    BForm,
    // BAlert,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    // BLink,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      recaptchaAction: RECAPTCHA_ACTION_LOGIN,
      userId: '',
      error: '',
      status: '',
      showResendEmailVerification: true,
      usernameEmail: '',
      password: '',
      loading: false,
      // validation rules
      required,
      email,
      custommessages: {
        required: 'Password harus diisi',
      },
      custommessages1: {
        required: 'Email harus diisi',
      },

      messageResendEmailVerification: '',
      loadingResendVerification: false,

      countTimerEmail: 60,

      // Mode Page
      modeVerificationEmail: false,
      modeLogin: true,

      fcmToken: '',
      NoSpace,

      isShowErrorForgotPassword: false,
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    return {
      // App Name
      appName,
      appLogoImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  watch: {
    usernameEmail() {
      this.error = ''
    },
    password() {
      this.error = ''
    },
  },
  methods: {
    showErrorToast(text) {
      this.$toast({
        component: ToastificationContentVue,
        props: {
          title: 'Gagal',
          text,
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    },
    login() {
      this.$refs.loginForm.validate().then(async success => {
        if (success) {
          this.loading = true
          this.showResendEmailVerification = false
          this.error = ''
          this.userId = ''

          let recaptchaToken = ''
          try {
            recaptchaToken = this.$refs.recaptcha
              ? await this.$refs.recaptcha.execute(this.recaptchaAction)
              : ''
          } catch (recaptchaErr) {
            const friendlyMessage = 'Verifikasi keamanan (reCAPTCHA) gagal. Silakan coba lagi.'
            this.error = friendlyMessage
            this.showErrorToast(friendlyMessage)
            this.loading = false
            return
          }

          useJwt
            .login({
              username_email: this.usernameEmail,
              password: this.password,
              recaptcha_token: recaptchaToken,
            })
            .then(response => {
              if (response.data.status === false && response.data.data) {
                const { data } = response.data
                this.$swal({
                  html: `<h3 class="font-bold text-2xl mt-[8px] text-[#333333]">Gagal Login</h3> <p class="my-[18px]">Tersisa ${data.login_attempt}x kesempatan untuk login. Apabila setelah 3x percobaan login tetap gagal, kamu dapat mencobanya lagi setelah 24 jam kedepan</p>`,
                  imageUrl:
                    'https://storage.googleapis.com/komerce/core/icon-popup-warning.png',
                  imageWidth: 104,
                  imageHeight: 100,
                  width: 600,
                  padding: '44px 24px',
                  confirmButtonText: 'Mengerti',
                  confirmButtonClass: 'btn btn-primary w-full',
                  customClass: {
                    actions: 'mt-0 px-0',
                  },
                })
              } else if (response.data.status === false) {
                this.error = response.data.message
                  || 'Maaf, username atau password yang Kamu masukan salah'
              } else if (
                response.data.data
                && response.data.data.email_verified_at === null
              ) {
                this.error = 'Email belum terverifikasi, silahkan verifikasi email-mu terlebih dahulu'
              } else {
                useJwt.setToken(response.data.data)
                this.getUser(response.data.data)
              }
            })
            .catch(error => {
              const res = error && error.response
              const resData = res && res.data
              const message = (resData && resData.meta && resData.meta.message)
                || (resData && resData.message)
                || ''
              const lowerMessage = message.toLowerCase()

              if (resData && resData.data && resData.data.login_attempt) {
                this.$swal({
                  html: `<h3 class="font-bold text-2xl mt-[8px] text-[#333333]">Gagal Login</h3> <p class="my-[18px]">Tersisa ${resData.data.login_attempt}x kesempatan untuk login. Apabila setelah 3x percobaan login tetap gagal, kamu dapat mencobanya lagi setelah 24 jam kedepan</p>`,
                  imageUrl:
                    'https://storage.googleapis.com/komerce/core/icon-popup-warning.png',
                  imageWidth: 104,
                  imageHeight: 100,
                  width: 600,
                  padding: '44px 24px',
                  confirmButtonText: 'Mengerti',
                  confirmButtonClass: 'btn btn-primary w-full',
                  customClass: {
                    actions: 'mt-0 px-0',
                  },
                })
              } else if (
                res
                && res.status === 400
                && (lowerMessage.includes('3x')
                  || lowerMessage.includes('kesempatan')
                  || lowerMessage.includes('0 attempt'))
              ) {
                this.$swal({
                  html:
                    '<h3 class="font-semibold text-2xl mt-[8px] text-[#333333]">Gagal Login</h3> <p class="my-[18px]">Login Gagal 3x. Silakan coba lagi setelah 24 jam ke depan</p>',
                  imageUrl:
                    'https://storage.googleapis.com/komerce/core/icon-popup-warning.png',
                  confirmButtonText: 'Mengerti',
                  imageWidth: 104,
                  imageHeight: 100,
                  width: 600,
                  padding: '44px 24px',
                  confirmButtonClass: 'btn btn-primary w-full',
                  customClass: {
                    actions: 'mt-0 px-0',
                  },
                })
              } else if (
                res
                && res.status === 400
                && lowerMessage.includes('incorrect password')
              ) {
                const attemptMatch = message.match(/(\d+)\s*attempt/i)
                const attempts = attemptMatch ? attemptMatch[1] : null
                const friendlyMessage = attempts
                  ? `Password salah, tersisa ${attempts} kesempatan lagi`
                  : 'Password yang kamu masukkan salah, silakan coba lagi'

                this.error = friendlyMessage
                this.showErrorToast(friendlyMessage)
              } else if (
                res
                && res.status === 400
                && lowerMessage.includes('recaptcha')
              ) {
                const friendlyMessage = 'Verifikasi reCAPTCHA tidak valid, silakan coba lagi'
                this.error = friendlyMessage
                this.showErrorToast(friendlyMessage)
              } else if (res && res.status === 403) {
                const friendlyMessage = 'Akun kamu tidak memiliki hak akses untuk masuk ke halaman ini'
                this.error = friendlyMessage
                this.showErrorToast(friendlyMessage)
              } else if (res && (res.status === 401 || res.status === 404)) {
                const friendlyMessage = 'Maaf, username atau password yang kamu masukkan salah'
                this.error = friendlyMessage
                this.showErrorToast(friendlyMessage)
              } else if (res && res.status === 422) {
                const friendlyMessage = (resData
                    && resData.data
                    && resData.data.errors
                    && resData.data.errors[0])
                  || message
                  || 'Data yang dimasukkan tidak valid'
                this.error = friendlyMessage
                this.showErrorToast(friendlyMessage)
              } else {
                const friendlyMessage = message || 'Gagal untuk login, silakan coba lagi!'
                this.error = friendlyMessage
                this.showErrorToast(friendlyMessage)
              }
            })
            .finally(() => {
              if (this.$refs.recaptcha) {
                this.$refs.recaptcha.reset()
              }
              this.loading = false
            })
        }
      })
    },
    loginKomcardsIframe() {
      return new Promise((resolve, reject) => {
        window.addEventListener(
          'message',
          event => {
            if (event.data.type === 'signin-complete') {
              resolve('OK')
            }
            if (event.data.type === 'signin-error') {
              reject()
            }
          },
          false,
        )
        const iframe = document.createElement('iframe')
        iframe.src = `${process.env.VUE_APP_URL_FRONTEND_NEW_MITRA}/iframe/login?username_email=${this.usernameEmail}&password=${this.password}`
        iframe.width = '0'
        iframe.height = '0'
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
      })
    },
    getUser(userData) {
      this.userId = userData.id
      this.$http
        .post('/user/get-profile', {
          user_id: this.userId,
        })
        .then(async response => {
          let ability = []

          let { data } = response.data
          data = Array.isArray(data) ? data[0] : data
          const roleType = data?.mitras?.mitra_type.toUpperCase()

          if (!['EKSPEDISI', 'WAREHOUSE', 'KOMCARDS'].includes(roleType)) {
            this.error = 'Akun anda tidak memiliki hak akses untuk masuk.'
            return
          }

          switch (roleType) {
            case 'KOMCARDS':
              ability = [
                {
                  action: 'manage',
                  subject: 'OverviewMonitoring',
                },
              ]
              break
            case 'EKSPEDISI':
              ability = [
                { action: 'manage', subject: 'Dashboard' },
                {
                  action: 'manage',
                  subject: 'Mitra Ticketing',
                },
                {
                  action: 'manage',
                  subject: 'MonitoringPickup',
                },
                { action: 'manage', subject: 'Pickup' },
              ]
              break
            case 'WAREHOUSE':
              ability = [
                { action: 'manage', subject: 'Pin' },
                { action: 'manage', subject: 'RekeningBank' },
                { action: 'manage', subject: 'Profile' },
                { action: 'manage', subject: 'carigudang' },
                { action: 'manage', subject: 'gudangku' },
                { action: 'manage', subject: 'InfoGudangku' },
                { action: 'manage', subject: 'StokGudang' },
                { action: 'manage', subject: 'DataInbound' },
                { action: 'manage', subject: 'Keuangan' },
                { action: 'manage', subject: 'Outbound' },
                {
                  action: 'manage',
                  subject: 'DashboardWarehouse',
                },
                { action: 'manage', subject: 'StorageRequest' },
              ]
              break
            default:
              break
          }

          data.ability = ability
          this.$ability.update(ability)

          secureLocalStorage.set('userData', data)
          this.$store.commit('auth/UPDATE_USER_DATA', data)

          if (roleType === 'KOMCARDS') {
            await this.loginKomcardsIframe().then(() => {
              this.$router.go(getHomeRouteForLoggedInUser('KOMCARDS'))
            })
          } else {
            this.$router.go(getHomeRouteForLoggedInUser(roleType))
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    resendEmailVerification() {
      this.loadingResendVerification = true
      this.showResendEmailVerification = true
      if (this.countTimerEmail !== 60) {
        this.countTimerEmail = 60
      }

      this.$http
        .get(`/resend_verification_email/${this.userId}`)
        .then(() => {
          this.error = ''
          this.loadingResendVerification = false
          this.modeLogin = false
          this.modeVerificationEmail = true
          this.countDownTimer()
        })
        .catch(() => {
          this.loadingResendVerification = false
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'Gagal',
              text: 'Gagal untuk login, silahkan coba lagi!',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
        })
    },
    getPartnerProfile(userId) {
      return this.$http
        .get(`/user/partner/get-profile/${userId}`)
        .then(response => response.data.data[0])
        .finally(() => {
          this.loading = false
        })
    },
    getAccessKomship(id) {
      const params = {
        user_id: id,
      }
      return this.$http
        .get('/user/partner/get-menu-komship-member', {
          params,
        })
        .then(response => response.data.data)
    },
    logout() {
      useJwt
        .logout({})
        .then(() => {
          // Remove userData from localStorage
          // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
          secureLocalStorage.clear(useJwt.jwtConfig.storageTokenKeyName)
          localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleChangeModePage() {
      this.modeVerificationEmail = false
      this.modeLogin = true
    },
    countDownTimer() {
      if (this.countTimerEmail > 0) {
        setTimeout(() => {
          this.countTimerEmail -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    handleClickForgotPassword() {
      this.isShowErrorForgotPassword = true

      setTimeout(() => {
        this.isShowErrorForgotPassword = false
      }, 4000)
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/pages/page-auth.scss';

.form-login {
  backdrop-filter: blur(8px) !important;
  background-color: #ffffffb2;
  border: 1px solid #e2e2e2;
}

.btn-submit {
  opacity: 1 !important;
  padding: 8px 0;
  font-weight: 500;
  outline: none;
  border-radius: 6px;
}

.btn-submit:focus {
  outline: none;
}

.no-icon .form-control.is-invalid {
  background-image: none !important;
}

.btnSubmitInvalid {
  color: #c2c2c2 !important;
  opacity: 1 !important;
  background: #f4f4f4 !important;
  border: 1px solid #e2e2e2 !important;
}

.btnSubmitValid {
  background: #f95031 !important;
  opacity: 1 !important;
  color: white !important;
}
</style>
